import { ShippingAddressEditForm } from './features/ShippingAddressEditForm';
import styles from './styles.module.scss';

type Props = {
  /** 企業コード（編集フォームに渡す） */
  threeLetterCode: React.ComponentProps<typeof ShippingAddressEditForm>['threeLetterCode'];
  /** 編集フォームの「キャンセル」押下時のコールバック（確認ビューへ戻す） */
  onCancel: React.ComponentProps<typeof ShippingAddressEditForm>['onCancel'];
  /** 編集フォームの保存成功時のコールバック（確認ビューへ戻す） */
  onSaved: React.ComponentProps<typeof ShippingAddressEditForm>['onSaved'];
};

/**
 * 送付先住所確認ダイアログの編集ビュー Presentation
 *
 * 確認ビューと同じダイアログ枠の中に編集フォーム（入れ子 feature の Container）を描画する。
 * 編集フォームは都道府県一覧を suspense 前提で取得するため、呼び出し側（Container）の
 * Suspense 境界の内側で描画すること。見出し（id: shipping-address-edit-form-title）は
 * 編集フォーム側が描画し、ダイアログの aria-labelledby はそれを参照する。
 */
export const ShippingConfirmationDialogEditPresentation: React.FC<Props> = ({
  threeLetterCode,
  onCancel,
  onSaved,
}) => {
  return (
    <div className={styles.overlay}>
      <div
        className={styles.dialog}
        role='dialog'
        aria-modal='true'
        aria-labelledby='shipping-address-edit-form-title'
      >
        <ShippingAddressEditForm
          threeLetterCode={threeLetterCode}
          onCancel={onCancel}
          onSaved={onSaved}
        />
      </div>
    </div>
  );
};
